import { PlusOutlined } from "@ant-design/icons";
import { couponApi } from "@api";
import {
  ComponentPagination,
  SearchFilter,
  SelectedFilter,
  SharedButton,
  StyledListPage,
  ComponentHeader,
  StyledInnerListPage,
  SharedIconButton,
  PlusIcon,
} from "@components";

import { cdicCouponCategory, enumFilter, initPage, PATH_CREATE_CDIC_PROGRAM, PATH_CREATE_SERVICE_NAME } from "@configs";
import { ICouponProgram, IFormExportValues, IPagination } from "@interfaces";
import { selectApp, setLoading } from "@redux";
import { useNotify } from "@utils";
import { Col, Row, Tooltip } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { CouponProgramTable } from "src/Modules/coupon/ProgramTable";
import { ExportSidebarCdic } from "./ExportCdic";

export const PageProgramList = () => {
  // hook
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const history = useHistory();
  const { success, error } = useNotify();
  const { mobile } = useSelector(selectApp);
  // state
  const [page, setPage] = useState<IPagination>(initPage);
  const [total, setTotal] = useState<number>(0);
  const [data, setData] = useState<ICouponProgram[]>([]);
  const [filters, setFilters] = useState<enumFilter | string>("");
  const [text, setText] = useState<string>("");
  const [date, setDate] = useState<string[]>([]);

  useEffect(() => {
    fetchCoupon();
  }, [page, text, date]);

  const fetchCoupon = async () => {
    try {
      dispatch(setLoading(true));
      const res = await couponApi.getProgramList({
        page: page.page,
        limit: page.limit,
        searchColumn: filters,
        search: text,
        startDate: date[0],
        endDate: date[1],
      });
      setData(res.data?.data);
      setTotal(res.data?.nTotal);
      success(t("message.fetch.success"));
    } catch (err: any) {
      error(t("message.fetch.fail"));
      dispatch(setLoading(false));
    } finally {
      dispatch(setLoading(false));
    }
  };
  const handlePagination = (current: number, size: number) => {
    setPage({ ...page, page: current, limit: size });
  };

  const goToCreate = () => history.push(PATH_CREATE_CDIC_PROGRAM);
  const goToCreateService = () => history.push(PATH_CREATE_SERVICE_NAME);
  const changeFilter = (value: string) => {
    setText("");
    setFilters(value);
  };
  const searchText = (value: string) => setText(value);
  const handleClearSearch = () => {
    setText("");
    setFilters("");
  };
  const button = (
    <>
      {mobile ? (
        <Tooltip title={t("page.add_new_coupon_family")}>
          <SharedIconButton type="primary" ghost icon={<PlusIcon />} onClick={goToCreate} />
        </Tooltip>
      ) : (
        <Row gutter={8}>
          <Col>
            <Tooltip title={t("page.add_new_service")}>
              <SharedButton
                  type="primary"
                  ghost
                  icon={<PlusOutlined />}
                  size="middle"
                  onClick={goToCreateService}
              >
                {t("page.add_service")}
              </SharedButton>
            </Tooltip>
          </Col>
          <Col>
            <Tooltip title={t("page.add_new_coupon_family")}>
              <SharedButton
                type="primary"
                ghost
                icon={<PlusOutlined />}
                size="middle"
                onClick={goToCreate}
              >
                {t("page.add_cf")}
              </SharedButton>
            </Tooltip>
          </Col>
        </Row>
      )}
    </>
  );

  return (
    <>
      <ComponentHeader title={t("page.cdic_program_management")} />
      <StyledListPage>
        <StyledInnerListPage>
          <SearchFilter
            actionBtn={button}
            filter={cdicCouponCategory}
            callbackFun={changeFilter}
            searchText={searchText}
            searchInputPlaceholder={t("page.search_user_by")}
            selectedOption={filters}
          />
          <SelectedFilter
            handleClearSearch={handleClearSearch} 
            selected={filters} 
            formDate={date[0]} 
            toDate={date[1]} 
          />
          <CouponProgramTable data={data} callback={fetchCoupon} />
          <ComponentPagination total={total} page={page.page} changePage={handlePagination} />
        </StyledInnerListPage>
      </StyledListPage>
    </>
  );
};
